import axios from 'axios'
import { Message } from 'element-ui'
import {
  ErrorMessageDisplayTime,
  ResponseSuccess
  // NOT_AUTHORIZED_CODE
} from '@/core/utils/codes'
import { getToken } from './token'
// 创建axios实例

export const baseUrl = '/api/wms/v1/warehouse'
const service = axios.create({
  baseURL: baseUrl, // api 的 base_url
  timeout: 20000 // 请求超时时间
})

// let jumpTimer = null
// const Handle401 = debounce(() => {
//   Message({
//     message: 'Credentials expired, please login again!',
//     type: 'error',
//     duration: ErrorMessageDisplayTime
//   })
//   if (jumpTimer) clearTimeout(jumpTimer)
//   jumpTimer = setTimeout(() => {
//     removeToken()
//     window.location.reload()
//   }, 2000)
// }, 2000)

export const ResultHandler = function (response, msg) {
  const { code } = response
  if (code === ResponseSuccess) {
    return response.data
  } else {
    // if (code === 401) {
    //   Handle401()
    // } else {
    Message({
      message: response.message || msg,
      type: 'error',
      duration: ErrorMessageDisplayTime
    })
    // }
    throw new Error(response.message)
  }
}

// request拦截器
service.interceptors.request.use(
  config => {
    config.headers.Authorization = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    config.headers.client = 'warehouse-web'
    return config
  },
  error => {
    console.error(error) // for debug
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  (error, response) => {
    // console.error('err' + error, error.response?.data) // for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service

export const AuthBaseUrl = '/api/wms/v1/auth'
export const AuthService = axios.create({
  baseURL: AuthBaseUrl, // api 的 base_url
  timeout: 20000 // 请求超时时间
})
AuthService.interceptors.request.use(
  config => {
    config.headers.client = 'warehouse-web'
    return config
  },
  error => {
    console.error(error) // for debug
  }
)
// response 拦截器
AuthService.interceptors.response.use(
  response => response.data,
  (error, response) => {
    return Promise.reject(error)
  }
)
